// Polyfill Promise for IE11 https://github.com/stefanpenner/es6-promise
// It's the official Polyfill linked from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise
// eslint-disable-next-line no-var
var Promise = require('es6-promise').Promise;

window.FCUTRECHT = function (method, url, payload, timeout, requestheader) {
    if (window.resetTimeout) window.resetTimeout();
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        if (requestheader) {
           xhr.setRequestHeader('Content-Type', requestheader);
        }
        xhr.timeout = timeout || 5000;
        xhr.onload = () => {
            handlePromiseXhrResponse(xhr, resolve, reject);
        };
        xhr.onerror = () => {
            console.log('ERROR', method, url, xhr);
            reject(xhr);
        };
        xhr.ontimeout = () => {
            console.log('TIMEOUT', method, url, xhr);
            reject(xhr);
        };
        xhr.send(payload);
    });
};

window.GET = function (url, timeout) {
    return FCUTRECHT('GET', url, null, timeout);
};

window.POST = function (url, payload, timeout) {
    return POSTBARE(url, JSON.stringify(payload), timeout);
};

window.POSTBARE = function (url, payload, timeout) {
    // When in fabricator, use GET to get /data json files
    return FCUTRECHT(process.env.NODE_ENV === 'production' ? 'POST' : 'GET', url, payload, timeout);
};

window.PUT = function (url, payload, timeout) {
    return FCUTRECHT('PUT', url, JSON.stringify(payload), timeout);
};

window.DELETE = function (url, timeout) {
    return FCUTRECHT('DELETE', url, null, timeout);
};

function handlePromiseXhrResponse (xhr, resolve, reject) {
    if (xhr.status >= 200 && xhr.status < 300) {       
        resolve(xhr);
    } else if (xhr.status == 401) {
        reject(xhr);
    } else {
        reject(xhr);
    }
}